import React from 'react'

import { Link } from 'react-router-dom'

const ListFriendAdd = ({ friendsPath }) => (
  <li className="friends-list-item">
    <Link to={friendsPath + '/invites'} className="friend-list__add">
      <span className="material-icons">person_add</span>
    </Link>
    <h3 className="friends-list-item__name">
      <Link to={friendsPath + '/invites'}>Add a Friend</Link>
    </h3>
  </li>
)

export default ListFriendAdd



// WEBPACK FOOTER //
// ./src/Components/ListFriendAdd.js